import { useRoutes, Navigate } from "react-router-dom";
import { protectedRoutes } from "./protected";
import { publicRoutes } from "./public";
import { Landing } from "../modules/misc";
import { getLivisToken, isTermsPending } from "../helpers/storage";
import { Suspense } from "react";

export const AppRoutes = () => {
  const token = getLivisToken();
  const termsPending = !!token && isTermsPending();

  const commonRoutes = [{ path: "/", element: <Landing /> }];
  let routes = token && !termsPending ? protectedRoutes : publicRoutes;

  if (termsPending) {
    // Authenticated but terms not accepted — only the auth module (terms-gate) is
    // reachable; bounce every other path back to the gate instead of 404ing.
    routes = routes.map((route: any) =>
      route.path === "*"
        ? { path: "*", element: <Navigate to="/auth/terms-gate" replace /> }
        : route
    );
  }

  const element = useRoutes([...routes, ...commonRoutes]);
  return <Suspense>{element}</Suspense>;
};
